import React, { Fragment } from "react"
import 'animate.css';

const AnimatedBackground = () => {
  let elementArray = []
  for (let index = 0; index < 10; index++) {
    let upOrDown = Math.floor(Math.random() * 10) % 2 === 0 ? 'Up' : 'Down'
    elementArray.push(
      <img
        key={index+1+'__animated-image'}
        src={`./assets/images/moving-images/${index+1}.png`} 
        className={`
          animated
          animate__animated 
          animate__fadeIn 
          
          move-${upOrDown} 
          animate__delay-2s 
          float-image 
          
        `}
        alt="shape" 
        style={{
          left: `${(index+1) * 8}%`,
          bottom: `${Math.random() *
            (+(index % 2 === 0 ? 40 : 20) - +(index % 2 === 0 ? 30 : 10)) +
            +(index % 2 === 0 ? 30 : 10)}%`,
        }}
      />
    )   
    
  }
  return elementArray
}
//`animated fadeIn move-${
//   Math.floor(Math.random() * 10) % 2 === 0 ? 'up' : 'down'
// } float-image`
export default AnimatedBackground